import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var contentRootLegacy = createRuntimeFn({defaultClassName:'contentLegacy_contentRootLegacy__ybwy2f0',variantClassNames:{layout:{column:'contentLegacy_contentRootLegacy_layout_column__ybwy2f1'}},defaultVariants:{},compoundVariants:[]});
var styledContentLegacy = 'contentLegacy_styledContentLegacy__ybwy2f4';

export { contentRootLegacy, styledContentLegacy };
//# sourceMappingURL=contentLegacy.vanilla.mjs.map
